import { isNil } from 'lodash-es'
import { styled } from 'styled-components'
import MenuItem from '../MenuItem'
import Text from '../Text'

const StyledMenuItem = styled(MenuItem)`
  padding: ${(p) => p.theme.spacings.sm}px;
`

interface PeriodItemProps {
  onPress: () => void
  forceActivity: boolean
  label: string
  sublabel?: string
}

const PeriodItem: FC<PeriodItemProps> = ({ onPress, forceActivity, label, sublabel }) => {
  return (
    <StyledMenuItem onPress={onPress} variant='list' forceActivity={forceActivity}>
      <Text>{label}</Text>
      {!isNil(sublabel) ? (
        <Text $fontSize='xs' $color='grayscale.700'>
          {sublabel}
        </Text>
      ) : null}
    </StyledMenuItem>
  )
}

export default PeriodItem
